import { HStack, Text } from '@chakra-ui/react'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'

import { SeriesWithdrawalSource } from '@/queries/constants'
import SeriesQ from '@/queries/SeriesQ'
import SeriesRegistrationQ from '@/queries/SeriesRegistrationQ'
import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'
import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

export default function SeriesUserWithdrawnBanner({
  series,
}: {
  series: Query
}): JSX.Element | null {
  const user = useUser()
  const seriesRegistration = series.one(SeriesQ.getMostRecentRegistration(user.id))

  const isWithdrawn = seriesRegistration(SeriesRegistrationQ.isWithdrawn()) ?? false
  const withdrawnAt = seriesRegistration(SeriesRegistrationQ.withdrawn_at)
  const withdrawnAtDateTime = DateTime.fromISO(`${withdrawnAt}`)
  const withdrawalSource = seriesRegistration(SeriesRegistrationQ.withdrawal_source)
  const withdrawalReason = seriesRegistration(SeriesRegistrationQ.withdrawal_reason)

  if (!isWithdrawn) {
    return null
  }

  if (withdrawalSource === SeriesWithdrawalSource.Tutor) {
    return (
      <HStack
        borderRadius="8px"
        p="24px"
        spacing="16px"
        backgroundColor="red.subtle"
        align="center"
      >
        <FontAwesomeIcon icon={faExclamationCircle} />
        <Text textAlign="left" ml="10px">
          The tutor withdrew you from this series on{' '}
          {withdrawnAtDateTime.toLocaleString(DateTime.DATE_SHORT)} for the following reason:{' '}
          <b>{withdrawalReason}</b>. To appeal to join the series again, please see this{' '}
          <ShwLink href={url.faq.getArticleUrl('removed-from-series')}>FAQ</ShwLink> for more
          information.
        </Text>
      </HStack>
    )
  }
  if (withdrawalSource === SeriesWithdrawalSource.Learner) {
    return (
      <HStack
        borderRadius="8px"
        p="24px"
        spacing="16px"
        backgroundColor="red.subtle"
        align="center"
      >
        <FontAwesomeIcon icon={faExclamationCircle} />
        <Text textAlign="left" ml="10px">
          You withdrew yourself from this series on{' '}
          {withdrawnAtDateTime.toLocaleString(DateTime.DATE_SHORT)}.
        </Text>
      </HStack>
    )
  }
  return null
}
